import { RootState } from "../../../index";

export const selectSigninData = (state: RootState) => state.signin.data;
export const selectPendingUser = (state: RootState) => state.signin.pending;
export const selectErrorUser = (state: RootState) => state.signin.error;
export const selectAuthenticatedUser = (state: RootState) =>
  state.signin.data?.email;
export const selectUserInfo = (state: RootState) => state.signin.user;
export const selectUserEmployeeInfo = (state: RootState) =>
  state.signin.employee;
